import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RefundFlowEndPoints} from 'main/factories/usecases';
import {GetAdditionalDocumentRequests} from 'domain/usecases';
import {RemoteGetAdditionalDocumentRequests} from 'data/usecases';

export const makeGetAdditionalDocumentRequests = (): GetAdditionalDocumentRequests =>
	new RemoteGetAdditionalDocumentRequests(
		makeBFFApiUrl(RefundFlowEndPoints.additionalDocumentsRequests),
		makeAuthorizeHttpClientDecorator(),
	);
